/* App.js */
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google"; // 1. Import the provider
import Home from "./components/home";
import Dashboard from "./components/dashboard";

// !! REPLACE WITH YOUR OWN CLIENT ID !!
// You can get this from the Google Cloud Console:
// https://console.cloud.google.com/apis/credentials
const GOOGLE_CLIENT_ID = "682965846321-pa2s3o4ql18kuutn7mmrci74hpesq4vj.apps.googleusercontent.com";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');

  return (
    // 2. Wrap your app with the provider
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <Router>
        <Routes>
          {/* Home Page (Passes setIsLoggedIn) */}
          {/* Home Page (Default Route) */}
          <Route 
            path="/" 
            element={
              isLoggedIn ? 
              <Navigate to="/dashboard" replace /> : // <-- If logged in, redirect
              <Home setIsLoggedIn={setIsLoggedIn} />   // <-- If not, show Home
            } 
          />

          {/* Protected Dashboard Route */}
          <Route
            path="/dashboard"
            element={
              isLoggedIn ? (
                <Dashboard setIsLoggedIn={setIsLoggedIn} /> // <-- Pass prop
              ) : (
                <Navigate to="/" replace /> // redirect to home if not logged in
              )
            }
          />
        </Routes>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;